import * as React from "react";
const SvgDashedLine = (props) => /* @__PURE__ */ React.createElement("svg", props, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M5 18a2 2 0 1 0 0 4h3a2 2 0 1 0 0-4H5Zm9 0a2 2 0 1 0 0 4h3a2 2 0 1 0 0-4h-3Zm7 2a2 2 0 0 1 2-2h3a2 2 0 1 1 0 4h-3a2 2 0 0 1-2-2Zm11-2a2 2 0 1 0 0 4h3a2 2 0 1 0 0-4h-3Z"
}));
export default SvgDashedLine;
